/**
 * Extract a user-friendly error string from any API error shape.
 * Handles: string, array of validation objects, nested detail, etc.
 */
export const extractErrorMessage = (err, fallback = 'Something went wrong') => {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === 'object' ? d.msg : String(d))).join('. ');
  }
  if (typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
};
